const viewEventDetailsClick = (event) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'viewEventDetailsClick',
        attributes: event
    });
};

export default {
    viewEventDetailsClick
};